<template>
  <div class="ttshop_user">
    <Header></Header>
    <Userheader></Userheader>
    <div class="ttshop_user">
      <div class="ttshop_usercon w clearfloat">
        <!-- 个人中心导航 -->
        <Usernavleft></Usernavleft>
        <div class="ttshop_useright">
          <div class="ttshop_usertop clearfloat">
            <div class="ttshop_usertopleft clearfloat">
              <div class="ttshop_userimg">
                <!-- <img class="img-default" src="../../assets/images/ttshop_userimg.jpg" alt=""> -->
                <img class="img-default" :src="user_info.avatar_url" alt="" />
              </div>
              <div class="ttshop_usertext">
                <h5>{{ user_info.binding }}</h5>
                <!-- <div class="ttshop_usertextcon clearfloat">
									<span>账户安全：</span>
									<div class="ttshop_jd"><i style="width: 40%;"></i></div>
									<strong>高</strong>
									<p>立即提升</p>
								</div> -->
                <div class="ttshop_dizhi" @click="goTtshop_siterun">
                  我的收货地址 >
                </div>
              </div>
            </div>
            <div class="ttshop_usertopright">
              <ul class="clearfloat">
                <!-- <li>
									<h5><span>9</span>张</h5>
									<p>优惠券</p>
								</li> -->
                <li style="width: 100%; text-align: center">
                  <h5>
                    <span>{{ user_info.money }}</span
                    >元
                  </h5>
                  <p>账户余额</p>
                </li>
                <!-- <li>
									<h5><span>20000</span>点</h5>
									<p>积分</p>
								</li> -->
              </ul>
              <div class="ttshop_userightbut clearfloat">
                <!-- <p>领券</p> -->
                <!-- <p
                  style="text-align: center; width: 100%"
                  @click="goTtshop_recharge"
                >
                  充值
                </p> -->
                <!-- <p>兑换商品</p> -->
              </div>
            </div>
          </div>
          <div class="ttshop_userconter clearfloat">
            <div class="ttshop_userconterleft">
              <div class="ttshop_usertitles clearfloat">
                <h4>我的订单</h4>
              </div>
              <div class="ttshop_userconterup clearfloat">
                <ul class="clearfloat">
                  <li @click="goOrder(0)">
                    <div class="ttshop_userconterimg">
                      <img
                        class="img-default user_img"
                        src="../../assets/images/ttshop_dfk.svg"
                        alt=""
                      />
                      <img
                        class="img-default user_imgs"
                        src="../../assets/images/ttshop_dfk1.svg"
                        alt=""
                      />
                    </div>
                    <p>待支付</p>
                  </li>
                  <li @click="goOrder(1)">
                    <div class="ttshop_userconterimg">
                      <img
                        class="img-default user_img"
                        src="../../assets/images/ttshop_dfh1.svg"
                        alt=""
                      />
                      <img
                        class="img-default user_imgs"
                        src="../../assets/images/ttshop_dfh.svg"
                        alt=""
                      />
                    </div>
                    <p>已支付</p>
                  </li>
                  <li @click="goOrder(2)">
                    <div class="ttshop_userconterimg">
                      <img
                        class="img-default user_img"
                        src="../../assets/images/ttshop_dsh1.svg"
                        alt=""
                      />
                      <img
                        class="img-default user_imgs"
                        src="../../assets/images/ttshop_dsh.svg"
                        alt=""
                      />
                    </div>
                    <p>待收货</p>
                  </li>
                  <li @click="goOrder(3)">
                    <div class="ttshop_userconterimg">
                      <img
                        class="img-default user_img"
                        src="../../assets/images/ttshop_dpj1.svg"
                        alt=""
                      />
                      <img
                        class="img-default user_imgs"
                        src="../../assets/images/ttshop_dpj.svg"
                        alt=""
                      />
                    </div>
                    <p>待评价</p>
                  </li>
                  <li @click="goOrder(4)">
                    <div class="ttshop_userconterimg">
                      <img
                        class="img-default user_img"
                        src="../../assets/images/ttshop_tk1.svg"
                        alt=""
                      />
                      <img
                        class="img-default user_imgs"
                        src="../../assets/images/ttshop_tk.svg"
                        alt=""
                      />
                    </div>
                    <p>退款/售后</p>
                  </li>
                </ul>
                <div class="ttshop_qb clearfloat">
                  <div class="ttshop_qbcon" @click="goOrder(-1)">
                    <div class="ttshop_userconterimg">
                      <img
                        class="img-default user_img"
                        src="../../assets/images/ttshop_all1.svg"
                        alt=""
                      />
                      <img
                        class="img-default user_imgs"
                        src="../../assets/images/ttshop_all.svg"
                        alt=""
                      />
                    </div>
                    <p>全部订单</p>
                  </div>
                </div>
              </div>
              <div class="ttshop_userbut">
                <div
                  class="ttshop_userbutshop clearfloat"
                  v-if="order_info.order.length"
                >
                  <div
                    class="ttshop_userbutshopleft clearfloat"
                    @click="goOrderxq(order_info.order[0].order_id)"
                  >
                    <div class="ttshop_userbutshopimg">
                      <img
                        class="img-default"
                        :src="order_info.order[0].goods_pic"
                        alt=""
                      />
                    </div>
                    <div class="ttshop_userbutshoptext">
                      <h5>{{ order_info.order[0].goods_name }}</h5>
                      <!-- <h6><span>白色</span> <span>170/M</span></h6> -->
                      <p>
                        ¥ <span>{{ order_info.order[0].price }}</span>
                      </p>
                    </div>
                  </div>
                  <div class="ttshop_userbutshopright">
                    <p
                      @click="
                        payOrder(
                          order_info.order[0].order_id,
                          order_info.order[0].price
                        )
                      "
                    >
                      立即支付
                    </p>
                  </div>
                </div>
                <!-- 暂无商品时展示 -->
                <div class="ttshop_userbutzw" v-else>
                  <p v-if="data_type">您暂无未支付商品</p>
                </div>
              </div>
            </div>
            <div class="ttshop_userconterright">
              <div class="ttshop_usertitles clearfloat">
                <h4>购物车</h4>
              </div>
              <!-- 暂无商品时显示 -->
              <div
                class="ttshop_carezw"
                v-show="Number(order_info.cart_count) == 0 && data_type"
              >
                <img
                  class="img-default"
                  src="../../assets/images/ttshop_zanwu.png"
                  alt=""
                />
                <p>购物车空空如也</p>
              </div>

              <div
                class="ttshop_cares"
                v-show="Number(order_info.cart_count) > 0"
              >
                <ul class="clearfloat d-flex justify-content-center">
                  <li v-for="(item, index) in order_info.cart" :key="index">
                    <img
                      class="img-default"
                      :src="item.pic_url"
                      alt=""
                      @click="goCat"
                    />
                  </li>
                </ul>
                <p @click="goCat">
                  <i
                    ><img
                      class="img-default"
                      src="../../assets/images/cat.svg"
                      alt=""
                    /><span>{{ order_info.cart_count }}</span></i
                  >
                  <strong>我的购物车</strong>
                </p>
              </div>
            </div>
          </div>
          <div class="ttshop_userbutton clearfloat">
            <div class="ttshop_userbuttonleft">
              <div class="ttshop_usertitles clearfloat">
                <h4>浏览记录</h4>
                <!-- <p>更多记录</p> -->
              </div>
              <div class="ttshop_userbuttonlist">
                <template v-if="history_list.length">
                  <div class="swiper-container browsing" ref="swipercon">
                      <ul class="clearfloat swiper-wrapper">
                        <li
                          v-for="(item, index) in history_list"
                          :key="index"
                          class="swiper-slide"
                          @click="toGoods(item.id)"
                        >
                          <div class="ttshop_userbuttonlistimg">
                            <img
                              class="img-default"
                              :src="item.cover_pic"
                              alt=""
                            />
                          </div>
                          <p v-text="item.name"></p>
                        </li>
                      </ul>
                  </div>
                </template>
                <div class="not-history-list" v-else>
                  <template v-if="data_type">您还没有浏览记录</template>
                </div>
              </div>
            </div>
            <div class="ttshop_userbuttonright">
              <div class="ttshop_usertitles clearfloat">
                <h4>我的收藏</h4>
              </div>
              <div class="ttshop_userbuttonrightlist">
                <ul class="clearfloat">
                  <li @click="shopcollect">
                    <h5 v-text="collection.goods_collection_count"></h5>
                    <p>收藏的商品</p>
                  </li>
                  <li @click="guanzhustore">
                    <h5 v-text="collection.mch_follow_count"></h5>
                    <p>关注的店铺</p>
                  </li>
                  <!-- <li>
										<h5 v-text="collection.topic_follow_count">300</h5>
										<p>收藏的专题</p>
									</li> -->
                </ul>
              </div>
            </div>
          </div>
          <div class="ttshop_userlast">
            <div class="ttshop_usertitles clearfloat">
              <h4>根据浏览，猜您喜欢</h4>
            </div>
            <template v-if="like_list.length">
              <div class="ttshop_userlastlist">
                <div class="swiper-container cc guess">
                  <ul class="swiper-wrapper clearfloat">
                    <template v-for="(item, index) in like_list">
                      <li class="swiper-slide" @click="toGoods(item.id)">
                        <div class="ttshop_userlastimg">
                          <img class="img-default" :src="item.cover_pic" />
                        </div>
                        <div class="ttshop_userlastext">
                          <p v-text="item.name">
                            微胖女生穿搭胖妹妹 大妈女装新款2020年
                          </p>
                        </div>
                      </li>
                    </template>
                  </ul>
                </div>
                <!-- 左右箭头 -->
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
              </div>
            </template>
            <div class="not-like-list" v-else>
              <template v-if="data_type">暂无相关商品</template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Foot></Foot>
    <div class="ttshop_pay">
      <el-dialog
        title=""
        :visible.sync="shopVisible"
        :before-close="payContTypeChange"
      >
        <div class="pay-title d-flex align-items-center justify-content-center">
          微信支付￥{{ payNum }}
        </div>
        <div
          class="pay-qrcode d-flex align-items-center justify-content-center"
        >
          <div id="qrcode" ref="qrcode"></div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Header from "@/components/header/header";
import Foot from "@/components/foot/foot";
import Userheader from "./components/user_index";
import Usernavleft from "./components/user_navleft";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import QRCode from "qrcodejs2";
let Base64 = require("js-base64").Base64;
import "./user.css";
export default {
  components: {
    Header,
    Userheader,
    Usernavleft,
    Foot,
  },
  data() {
    return {
      data_type: false,
      user_info: [],
      order_info: {
        cart: [],
        cart_count: 0,
        order: [],
      },
      collection: {}, //我的收藏
      history_list: [], //浏览记录
      like_list: [], //猜您喜欢
      shopVisible: false,
      payNum: "",
      time: "",
    };
  },
  created() {
    this.userIndex();
  },
  methods: {
    userIndex() {
      this.data_type = false;
      this.$api
        .userIndex({})
        .then((res) => {
          this.data_type = true;
          this.user_info = res.data.user; //用户信息
          this.order_info = res.data.order; //订单信息
          this.collection = res.data.collection; //我的收藏
          this.history_list = res.data.history; //浏览记录
          this.like_list = res.data.youLike; //猜您喜欢
          setTimeout(() => {
            new Swiper(".guess", {
              slidesPerView: 4,
              spaceBetween: 32,
              observer: true,
              observeParents: true,
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
            });
            new Swiper(".browsing", {
              slidesPerView: 4,
              spaceBetween: 32,
              observer: true,
              observeParents: true,
            });
          }, 0);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    goTtshop_recharge() {
      this.$router.push("/ttshop_recharge");
    },
    // 购物车
    goCat() {
      this.$router.push("/cat");
    },
    //收藏的商品
    shopcollect() {
      this.$router.push("/ttshop_mycollection");
    },
    //关注的店铺
    guanzhustore() {
      this.$router.push("/ttshop_store");
    },
    //地址列表
    goTtshop_siterun() {
      this.$router.push("/ttshop_siterun");
    },
    // 商品详情
    toGoods(id) {
      let url = this.$router.resolve({
        path: "/pages/goods/goods",
        query: {
          id: id,
        },
      });
      window.open(url.href);
    },
    // 去订单
    goOrder(index) {
      this.$router.push({
        path: "/ttshop_usermyorder",
        query: {
          tab: index,
        },
      });
    },
    //订单详情
    goOrderxq(id) {
      this.$router.push({
        path: "/ttshop_orderxq",
        query: {
          id: id,
        },
      });
    }, // 支付二维码关闭
    payContTypeChange() {
      let that = this;
      that
        .$confirm("是否取消支付", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
        .then(() => {
          that.shopVisible = false;
          clearInterval(this.time);
          // that.$router.replace({
          //   path: "/ttshop_usermyorder",
          //   query: {},
          // });
        })
        .catch(() => {
          console.log("取消");
        });
    },
    //支付
    payOrder(id, payNum) {
      let _this = this;
      this.payNum = payNum;
      _this.$api
        .orderPay({
          pay_type: "WECHAT_PAY",
          order_id: id,
        })
        .then((res) => {
          _this.shopVisible = true;
          // this.list = res.data
          _this.time = setInterval(() => {
            _this.orderStatus(res.res.order_no);
          }, 5000);
          let url = Base64.decode(res.res.code_url);
          setTimeout(function () {
            _this.qrcodeScan(url);
          }, 100);
        })
        .catch((err) => {
          // this.user = err;
        });
    },
    qrcodeScan(url) {
      this.$refs.qrcode.innerHTML = "";
      //生成二维码
      let qrcode = new QRCode("qrcode", {
        width: 150, // 二维码宽度
        height: 150, // 二维码高度
        text: url,
      });
    },
    //订单状态
    orderStatus(order) {
      if (this.shopVisible == false) {
        clearInterval(this.time);
        console.log("123");
      }
      this.$api
        .orderStatus({
          order_no: "order_" + order,
        })
        .then((res) => {
          if (res.code == 0) {
            clearInterval(this.time);
            this.$message({
              type: "success",
              message: res.msg,
              showClose: true,
              offset: 200,
              duration: 1000,
            });
            this.shopVisible = false;
            this.$router.push("/ttshop_usermyorder");
          }
        })
        .catch((err) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.ttshop_user {
  width: 100%;

  .ttshop_usercon {
    padding-top: 20px;
    padding-bottom: 60px;
    box-sizing: border-box;

    .ttshop_useright {
      width: 990px;
      float: right;

      .ttshop_usertop {
        width: 100%;
        margin-bottom: 10px;

        .ttshop_usertopleft {
          float: left;
          width: 490px;
          height: 150px;
          background: #fff;
          margin-right: 10px;
          padding: 35px 20px;
          box-sizing: border-box;

          .ttshop_userimg {
            float: left;
            width: 80px;
            height: 80px;
            border-radius: 50%;
            margin-right: 16px;

            img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: cover;
              border-radius: 50%;
            }
          }
        }

        .ttshop_usertext {
          float: left;

          h5 {
            font-size: 16px;
            color: #333;
            font-weight: 500;
            line-height: 16px;
            margin-bottom: 20px;
          }

          .ttshop_usertextcon {
            width: 100%;
            margin-bottom: 20px;

            span {
              font-size: 12px;
              color: #333;
              font-weight: 400;
              line-height: 12px;
              float: left;
            }

            .ttshop_jd {
              float: left;
              width: 124px;
              height: 12px;
              border-radius: 25px;
              background: #ebebeb;
              position: relative;
              overflow: hidden;
              margin-right: 12px;

              i {
                position: absolute;
                top: 0;
                left: 0;
                height: 12px;
                border-radius: 25px;
                background: linear-gradient(90deg, #ff9010, #ff0e25);
                background: -moz-linear-gradient(90deg, #ff9010, #ff0e25);
                background: -webkit-gradient(90deg, #ff9010, #ff0e25);
                background: -ms-linear-gradient(90deg, #ff9010, #ff0e25);
                filter: progid:DXImageTransform.Microsoft.gradient(GradientType=1, startColorstr=#FF9010, endColorstr=#FF0E25);
              }
            }
          }

          strong {
            float: left;
            font-size: 12px;
            color: #ff0e25;
            margin-right: 20px;
            font-weight: 500;
            line-height: 12px;
          }

          p {
            float: left;
            font-size: 12px;
            color: #0e9cff;
            font-weight: 400;
            line-height: 12px;
            cursor: pointer;
            opacity: 0.7;
            transition: 0.5s;
            -moz-transition: 0.5s;
            -webkit-transition: 0.5s;
            -o-transition: 0.5s;

            &:hover {
              opacity: 1;
            }
          }
        }

        .ttshop_dizhi {
          font-size: 12px;
          color: #333;
          font-weight: 400;
          line-height: 12px;
          transition: 0.5s;
          -moz-transition: 0.5s;
          -webkit-transition: 0.5s;
          -o-transition: 0.5s;
          cursor: pointer;

          &:hover {
            color: #ff0e25;
          }
        }

        .ttshop_usertopright {
          float: right;
          width: 490px;
          height: 150px;
          background: #fff;
          padding: 27px 40px;
          box-sizing: border-box;

          ul {
            margin-bottom: 14px;

            li {
              float: left;
              width: 38%;

              h5 {
                font-size: 12px;
                color: #666;
                font-weight: 500;
                margin-bottom: 10px;

                span {
                  font-size: 32px;
                  color: #333;
                  margin-right: 4px;
                }
              }

              p {
                font-size: 12px;
                color: #333;
              }
            }

            & li:first-child {
              width: 24%;
            }
          }

          .ttshop_userightbut {
            width: 100%;

            p {
              float: left;
              width: 38%;
              font-size: 12px;
              color: #0e9cff;
              opacity: 0.7;
              transition: 0.5s;
              -moz-transition: 0.5s;
              -webkit-transition: 0.5s;
              -o-transition: 0.5s;
              cursor: pointer;

              &:hover {
                opacity: 1;
              }
            }

            & p:first-child {
              width: 24%;
            }
          }
        }
      }

      .ttshop_usertitles {
        width: 100%;
        height: 40px;
        border-bottom: 1px solid #f2f2f2;
        padding: 0 20px;
        box-sizing: border-box;
        line-height: 40px;

        h4 {
          float: left;
          font-size: 16px;
          color: #999;
          font-weight: 500;
        }

        p {
          float: right;
          font-size: 12px;
          color: #666;
          font-weight: 400;
          transition: 0.5s;
          -moz-transition: 0.5s;
          -webkit-transition: 0.5s;
          -o-transition: 0.5s;
          cursor: pointer;

          &:hover {
            color: #ff0e25;
          }
        }
      }

      .ttshop_userconter {
        width: 100%;
        margin-bottom: 10px;

        .ttshop_userconterleft {
          float: left;
          width: 690px;
          margin-right: 10px;
          height: 271px;
          background: #fff;

          .ttshop_userconterup {
            width: 100%;
            height: 110px;
            border-bottom: 1px solid #f2f2f2;
            padding: 20px 27px;
            box-sizing: border-box;

            ul {
              float: left;
              width: 85%;

              li {
                float: left;
                width: 70px;
                height: 70px;
                padding-top: 7px;
                box-sizing: border-box;
                border-radius: 4px;
                transition: 0.5s;
                -moz-transition: 0.5s;
                -webkit-transition: 0.5s;
                -o-transition: 0.5s;
                cursor: pointer;
                margin-right: 44px;

                .ttshop_userconterimg {
                  width: 36px;
                  height: 36px;
                  position: relative;
                  overflow: hidden;
                  margin: 0 auto 6px;

                  .user_img {
                    display: block;
                    transition: 0.5s;
                    -moz-transition: 0.5s;
                    -webkit-transition: 0.5s;
                    -o-transition: 0.5s;
                  }

                  .user_imgs {
                    position: absolute;
                    top: -36px;
                    left: 0;
                    transition: 0.5s;
                    -moz-transition: 0.5s;
                    -webkit-transition: 0.5s;
                    -o-transition: 0.5s;
                  }
                }

                p {
                  font-size: 12px;
                  color: #999;
                  text-align: center;
                  line-height: 12px;
                  font-weight: 400;
                }

                &:hover {
                  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
                }

                &:hover .user_img {
                  opacity: 0;
                }

                &:hover .user_imgs {
                  top: 0;
                }
              }

              & li:last-child {
                margin-right: 0;
              }
            }

            .ttshop_qb {
              float: right;
              width: 15%;

              .ttshop_qbcon {
                float: right;
                width: 70px;
                height: 70px;
                padding-top: 7px;
                box-sizing: border-box;
                border-radius: 4px;
                transition: 0.5s;
                -moz-transition: 0.5s;
                -webkit-transition: 0.5s;
                -o-transition: 0.5s;
                cursor: pointer;

                .ttshop_userconterimg {
                  width: 36px;
                  height: 36px;
                  position: relative;
                  overflow: hidden;
                  margin: 0 auto 6px;

                  .user_img {
                    display: block;
                    transition: 0.5s;
                    -moz-transition: 0.5s;
                    -webkit-transition: 0.5s;
                    -o-transition: 0.5s;
                  }

                  .user_imgs {
                    position: absolute;
                    top: -36px;
                    left: 0;
                    transition: 0.5s;
                    -moz-transition: 0.5s;
                    -webkit-transition: 0.5s;
                    -o-transition: 0.5s;
                  }
                }

                p {
                  font-size: 12px;
                  color: #999;
                  text-align: center;
                  line-height: 12px;
                  font-weight: 400;
                }

                &:hover {
                  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
                }

                &:hover .user_img {
                  opacity: 0;
                }

                &:hover .user_imgs {
                  top: 0;
                }
              }
            }
          }

          .ttshop_userbut {
            width: 100%;
            height: 120px;

            .ttshop_userbutzw {
              width: 100%;
              text-align: center;
              line-height: 120px;

              p {
                font-size: 14px;
                color: #999;
              }
            }

            .ttshop_userbutshop {
              width: 100%;
              padding: 20px;
              box-sizing: border-box;

              .ttshop_userbutshopleft {
                float: left;
                width: 480px;

                .ttshop_userbutshopimg {
                  float: left;
                  width: 80px;
                  height: 80px;
                  margin-right: 16px;

                  img {
                    display: block;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                  }
                }

                .ttshop_userbutshoptext {
                  float: left;
                  width: 375px;

                  h5 {
                    font-size: 12px;
                    color: #666;
                    font-weight: 400;
                    line-height: 18px;
                    max-height: 36px;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                    margin-bottom: 4px;
                  }

                  h6 {
                    font-weight: 400;
                    margin-bottom: 4px;

                    span {
                      font-size: 12px;
                      color: #666;
                    }
                  }

                  p {
                    font-size: 12px;
                    color: #333;
                    font-weight: 400;
                    line-height: 18px;

                    span {
                      color: #333;
                    }
                  }
                }
              }

              .ttshop_userbutshopright {
                float: right;

                p {
                  width: 96px;
                  height: 28px;
                  border-radius: 2px;
                  text-align: center;
                  line-height: 28px;
                  font-size: 12px;
                  color: #666;
                  border: 1px solid #ebebeb;
                  transition: 0.5s;
                  -moz-transition: 0.5s;
                  -webkit-transition: 0.5s;
                  -o-transition: 0.5s;
                  cursor: pointer;
                  margin-top: 23px;

                  &:hover {
                    color: #ff0e25;
                    border-color: #ff0e25;
                  }
                }
              }
            }
          }
        }

        .ttshop_userconterright {
          float: right;
          width: 290px;
          height: 271px;
          background: #fff;

          .ttshop_carezw {
            width: 100%;
            height: 231px;
            padding-top: 40px;
            box-sizing: border-box;

            img {
              display: block;
              width: 93px;
              height: 80px;
              margin: 0 auto 15px;
            }

            p {
              font-size: 14px;
              text-align: center;
              color: #333;
            }
          }

          .ttshop_cares {
            width: 100%;
            height: 231px;
            padding: 31px 20px;
            box-sizing: border-box;

            ul {
              margin-bottom: 24px;

              li {
                float: left;
                width: 115px;
                height: 113px;
                margin-right: 20px;
                cursor: pointer;
                overflow: hidden;

                img {
                  display: block;
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                  transition: 0.5s;
                  -moz-transition: 0.5s;
                  -webkit-transition: 0.5s;
                  -o-transition: 0.5s;
                }

                &:hover img {
                  -webkit-transform: scale(1.2);
                  -moz-transform: scale(1.2);
                  -o-transform: scale(1.2);
                  -ms-transform: scale(1.2);
                  transform: scale(1.2);
                }
              }

              & li:last-child {
                margin-right: 0;
              }
            }

            p {
              display: block;
              width: 158px;
              height: 32px;
              border: 1px solid #ff0e25;
              text-align: center;
              line-height: 32px;
              border-radius: 2px;
              margin: 0 auto;
              cursor: pointer;
              transition: 0.5s;
              -moz-transition: 0.5s;
              -webkit-transition: 0.5s;
              -o-transition: 0.5s;

              i {
                position: relative;
                display: inline-block;
                width: 18px;
                height: 18px;
                margin-right: 12px;
                vertical-align: -2px;
                font-style: normal;

                img {
                  display: block;
                }

                span {
                  position: absolute;
                  top: -4px;
                  left: 10px;
                  right: auto;
                  display: inline-block;
                  padding: 1px 3px;
                  font-size: 12px;
                  line-height: 12px;
                  color: #fff;
                  background-color: #e1251b;
                  border-radius: 7px;
                  min-width: 12px;
                  text-align: center;
                }
              }

              strong {
                font-size: 12px;
                color: #ff0e25;
                font-weight: 500;
              }

              &:hover {
                box-shadow: 0 0 10px rgba(255, 14, 37, 0.3);
              }
            }
          }
        }
      }

      .ttshop_userbutton {
        width: 100%;
        margin-bottom: 10px;

        .ttshop_userbuttonleft {
          float: left;
          width: 690px;
          height: 224px;
          margin-right: 10px;
          background: #fff;

          .ttshop_userbuttonlist {
            width: 100%;
            height: 184px;
            padding: 24px 20px 28px 20px;
            box-sizing: border-box;

            ul {
              width: 100%;
              display: flex;
              align-items: center;
              li {
                float: left;
                width: 18%;
                margin-right: 2.5%;
                cursor: pointer;

                .ttshop_userbuttonlistimg {
                  width: 80px;
                  height: 80px;
                  display: block;
                  margin: 0 auto 16px;
                  overflow: hidden;

                  img {
                    display: block;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    transition: 0.5s;
                    -moz-transition: 0.5s;
                    -webkit-transition: 0.5s;
                    -o-transition: 0.5s;
                  }
                }

                p {
                  font-size: 12px;
                  color: #666;
                  font-weight: 400;
                  line-height: 18px;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                  overflow: hidden;
                  transition: 0.5s;
                  -moz-transition: 0.5s;
                  -webkit-transition: 0.5s;
                  -o-transition: 0.5s;
                  padding-left: 5px;
                  box-sizing: border-box;
                }

                &:hover img {
                  -webkit-transform: scale(1.2);
                  -moz-transform: scale(1.2);
                  -o-transform: scale(1.2);
                  -ms-transform: scale(1.2);
                  transform: scale(1.2);
                }

                &:hover p {
                  color: #ff0e25;
                }
              }

              & li:last-child {
                margin-right: 0;
              }
            }
          }
        }

        .ttshop_userbuttonright {
          float: right;
          width: 290px;
          background: #fff;

          .ttshop_userbuttonrightlist {
            width: 100%;
            height: 184px;
            padding: 30px 20px;
            box-sizing: border-box;

            ul {
              width: 100%;

              li {
                float: left;
                width: 49%;
                margin-right: 2%;
                text-align: center;
                margin-bottom: 20px;
                cursor: pointer;

                h5 {
                  font-size: 20px;
                  color: #333;
                  font-weight: 400;
                  line-height: 20px;
                  margin-bottom: 17px;
                  transition: 0.5s;
                  -moz-transition: 0.5s;
                  -webkit-transition: 0.5s;
                  -o-transition: 0.5s;
                }

                p {
                  font-size: 12px;
                  color: #999;
                  font-weight: 400;
                  line-height: 12px;
                  transition: 0.5s;
                  -moz-transition: 0.5s;
                  -webkit-transition: 0.5s;
                  -o-transition: 0.5s;
                }

                &:hover h5 {
                  color: #ff0e25;
                }

                &:hover p {
                  color: #ff0e25;
                }
              }

              & li:nth-child(2n) {
                margin-right: 0;
              }
            }
          }
        }
      }

      .ttshop_userlast {
        width: 100%;
        background: #fff;
        height: 384px;

        .ttshop_userlastlist {
          width: 100%;
          height: 344px;
          padding: 32px 79px;
          box-sizing: border-box;
          position: relative;

          .swiper-button-prev {
            width: 32px;
            height: 32px;
            background: url(../../assets/images/ttshop_userleft.png) center
              no-repeat;
            left: 27px;
            outline: none;
            top: 39%;
          }

          .swiper-button-prev::after {
            display: none;
          }

          .swiper-button-next {
            width: 32px;
            height: 32px;
            background: url(../../assets/images/ttshop_useright.png) center
              no-repeat;
            right: 27px;
            outline: none;
            top: 39%;
          }

          .swiper-button-next::after {
            display: none;
          }

          .swiper-slide {
            cursor: pointer;
          }

          .ttshop_userlastimg {
            width: 184px;
            height: 184px;
            margin: 0 auto 22px;
            overflow: hidden;

            img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: cover;
              transition: 0.5s;
              -moz-transition: 0.5s;
              -webkit-transition: 0.5s;
              -o-transition: 0.5s;
            }
          }

          .ttshop_userlastext {
            width: 100%;
            padding: 0 26px;
            box-sizing: border-box;

            p {
              font-size: 14px;
              color: #333;
              line-height: 20px;
              font-weight: 400;
              max-height: 40px;
              text-align: center;
              margin-bottom: 13px;
              transition: 0.5s;
              -moz-transition: 0.5s;
              -webkit-transition: 0.5s;
              -o-transition: 0.5s;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
            }

            h5 {
              font-size: 16px;
              color: #ff0e25;
              text-align: center;
              font-weight: 400;

              span {
                font-size: 16px;
                color: #ff0e25;
              }
            }
          }

          .swiper-slide:hover img {
            -webkit-transform: scale(1.2);
            -moz-transform: scale(1.2);
            -o-transform: scale(1.2);
            -ms-transform: scale(1.2);
            transform: scale(1.2);
          }

          .swiper-slide:hover p {
            color: #ff0e25;
          }
        }
      }
    }
  }
}

.ttshop_pay {
  .pay-title {
    width: 100%;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .pay-qrcode {
    width: 200px;
    height: 200px;
  }
}

.not-history-list,
.not-like-list {
  text-align: center;
  line-height: 132px;
  font-size: 14px;
  color: #999;
}

.not-like-list {
  line-height: 344px;
}
</style>
